import PubSub from "underpub-js";

var ModalsContainer = function(options) {

	this.options = {
		$el: false,
		baseClass: 'layout-ModalsContainer',
	};

	$.extend(true, this.options, options);

};

ModalsContainer.prototype.init = function() {

	var self = this;

};

export default ModalsContainer;
